import { createApiHooks, httpStatusAsData } from '@apis/next/common';
import { PrefAndCityByZipcode, PrefAndCityByPref, ProvAndCityByZipcode } from '@models/next/FC';
import { z } from 'zod';

export const fcApis = createApiHooks('/fc', [
  {
    method: 'get',
    path: '/pref-and-city-by-zipcode',
    parameters: [
      {
        type: 'Query',
        name: 'zipcode',
        schema: z.string(),
      },
    ],
    response: PrefAndCityByZipcode.nullable(),
  },
  {
    method: 'get',
    path: '/pref-and-city',
    parameters: [
      {
        type: 'Query',
        name: 'pref',
        schema: z.string(),
      },
    ],
    response: PrefAndCityByPref,
  },
  {
    method: 'get',
    path: '/prov-and-city-by-zipcode',
    parameters: [
      {
        type: 'Query',
        name: 'zipcode',
        schema: z.string(),
      },
    ],
    response: ProvAndCityByZipcode,
  },
]);

fcApis.client.use('get', '/fc/pref-and-city-by-zipcode', httpStatusAsData(404, null));
fcApis.client.use('get', '/fc/prov-and-city-by-zipcode', httpStatusAsData(404, null));
